import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {doppeActionTypePlaceholder} from "./doppe-action-type-placeholder";

export const doppeActionTypePlaceholderViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypePlaceholder, {
    loadViewerComponents: async () => {
        return {
            DoppeActionTypePlaceholderSkeleton: (await import('./doppe-action-type-placeholder-skeleton/doppe-action-type-placeholder-skeleton')).DoppeActionTypePlaceholderSkeleton
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypePlaceholderSkeleton
        } = viewerComponents;

        return (
            <DoppeActionTypePlaceholderSkeleton
                {...renderProps}
            />
        );

    },

})
